import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";

const LoginPage = () => {
  const [step, setStep] = useState("login");
  const [rollno, setRollno] = useState("");
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [name, setName] = useState("");
  const [father, setFather] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const [timerRunning, setTimerRunning] = useState(false);

  // Modal state
  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let timerInterval;

    if (timerRunning && timer > 0) {
      timerInterval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (timer === 0) {
      clearInterval(timerInterval);
      setModalMessage("OTP has expired. Please request a new one.");
      setShowModal(true);
      setStep("login");
    }

    return () => clearInterval(timerInterval);
  }, [timer, timerRunning]);

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://testresult.omegacareerinstitute.com/admin/welcome/matchRollNo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ rollno }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setGeneratedOtp(data.otp);
        setName(data.name);
        setMobile(data.mobile);
        setFather(data.fathername);
        setStep("otp");
      } else {
        setModalMessage(data.message || "Roll number not found.");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error:", error);
      setModalMessage("An error occurred. Please try again.");
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    const otpLast4 = otp.slice(-4);
    const genOtpLast4 = generatedOtp.slice(-4);

    if (otpLast4 === genOtpLast4) {
      navigate("/dashboard");

      localStorage.setItem("rollno", rollno);
      localStorage.setItem("mobile", otp);
      localStorage.setItem("name", name);
      localStorage.setItem("father", father);
      localStorage.setItem("studentmobile", mobile);
    } else {
      setModalMessage("Incorrect mobile number. Please try again.");
      setShowModal(true);
      setStep("login");
    }
  };

  const handleBackToPhone = () => setStep("login");

  return (
    <div
      className="container-fluid min-vh-100 d-flex justify-content-center align-items-center  p-2"
      style={{ paddingBottom: "40px" }}
    >
      <div className="w-100" style={{ maxWidth: "380px" }}>
        {/* LOGIN SCREEN */}
        {step === "login" && (
          <div className="card shadow p-4" style={{ borderRadius: "15px" }}>
            <div className="text-center mb-3">
              <img
                src="https://omegacareerinstitute.com/upload/30c33-logo-1.png"
                alt="Logo"
                className="img-fluid"
                style={{ maxWidth: "180px" }}
              />
              <h5 className="mt-2 fw-bold">Omega Career Institute</h5>
            </div>

            <h4 className="text-center mb-3 fw-semibold">Login</h4>

            <form onSubmit={handlePhoneSubmit}>
              <div className="mb-3">
                <label className="form-label">Roll No.</label>
                <input
                  type="tel"
                  className="form-control form-control-lg"
                  placeholder="Enter your roll number"
                  value={rollno}
                  onChange={(e) => setRollno(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 btn-lg"
                disabled={loading}
              >
                {loading ? (
                  <div className="spinner-border spinner-border-sm text-light"></div>
                ) : (
                  "Proceed"
                )}
              </button>
            </form>
          </div>
        )}

        {/* OTP SCREEN */}
        {step === "otp" && (
          <div className="card shadow p-4" style={{ borderRadius: "15px" }}>
            <h4 className="text-center mb-3 fw-semibold">Verify Mobile Number</h4>

            <form onSubmit={handleOtpSubmit}>
              <div className="mb-3">
                <label className="form-label">Registered Mobile No.</label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="XXXXXX1234"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary w-100 btn-lg">
                Login
              </button>

              <button
                type="button"
                className="btn btn-secondary w-100 mt-2 btn-lg"
                onClick={handleBackToPhone}
              >
                Back
              </button>
            </form>
          </div>
        )}
      </div>

      {/* MODAL */}
      {showModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title fw-semibold">Omega Career Institute</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <p className="mb-0 " style={{color:'red'}}>{modalMessage}</p>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => setShowModal(false)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
